import * as CryptoJS from 'crypto-js';

export class CryptoService {


  encryptQueryString(stringToEncrypt: string, key: string, iv: string): string {

    const keyBytes = CryptoJS.enc.Base64.parse(key);
    const ivBytes = CryptoJS.enc.Base64.parse(iv);

    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(stringToEncrypt),
      keyBytes,
      {
        iv: ivBytes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    // Base64 output
    let encryptedData = encrypted.ciphertext.toString(CryptoJS.enc.Base64);

    // URL-safe replacement (same as .NET)
    encryptedData = encryptedData.replace(/\+/g, '_');
    encryptedData = encryptedData.replace(/\//g, '-');

    return encryptedData;
  }


  decryptQueryString(stringToDecrypt: string, key: string, iv: string): string {

    let value = stringToDecrypt.replace(/_/g, '+').replace(/-/g, '/');

    const keyBytes = CryptoJS.enc.Base64.parse(key);
    const ivBytes = CryptoJS.enc.Base64.parse(iv);

    const decrypted = CryptoJS.AES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(value)
      } as any,
      keyBytes,
      {
        iv: ivBytes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
